module.exports = __webpack_public_path__ + "static/img/y3.0b1e46a3.jpg";